require('./depositChangeAccountView.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { withRouter } = require('react-router-dom');

// @ actions
const depositChangeAccountActions = require('actions/contactCenter/depositChangeAccount');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { LoadingSection } = require('commonsComponents/loadingSection');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox.js');
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const OKHeaderCC = require('components/commons/OKHeaderCC/OKHeaderCC');
const VerifyOtpStep = require('components/commons/verifyOtpStep/verifyOtpStep');
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const PreleaveCancelModal = require('components/contactCenter/preleaveCancelModal/preleaveCancelModal');

// @ helpers
const { formatIbanString } = require('commonsUtilities/stringHelper');

// @ constants
const { WIZARD_VERTICAL_VIEW_MODE, FIRST_STEP, API_ENTERPRISE_NUMBER, API_CENTER, EMPTY_CONCEPT } = require('constants/index');
const { DEPOSIT_CHANGE_ACCOUNT } = require('constants/contactCenter/operationTypes');

class DepositChangeAccountView extends React.Component {
    constructor(props) {
        super(props);
        this.handleCancelWizard = this.handleCancelWizard.bind(this);
        this.handleHideCancelModal = this.handleHideCancelModal.bind(this);
        this.handleAccountFromChange = this.handleAccountFromChange.bind(this);
        this.handleShowCancelModal = this.handleShowCancelModal.bind(this);
        this.handleErrorGoBack = this.handleErrorGoBack.bind(this);
    }

    componentWillMount() {
        const { match: { params: { depositId } }, requestAsociatedAccount, setDepositId } = this.props;
        const deposit = this.getDeposit();

        requestAsociatedAccount(deposit);
        setDepositId(depositId);
    }

    componentWillUnmount() {
        const { resetWizard, } = this.props;
        resetWizard();
    }

    handleShowCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(true);
    }

    handleHideCancelModal() {
        const { showCancelModal } = this.props;
        showCancelModal(false);
    }

    handleCancelWizard() {
        const cancelPath = '/myprofile/deposits';
        this.props.history.push(cancelPath);
    }

    handleGoBack() {
        const { resetWizard } = this.props;
        resetWizard();
    }

    handleErrorGoBack() {
        this.props.history.push('/myprofile/deposits');
    }

    getDeposit() {
        const { match: { params: { depositId } }, immGlobalPosition } = this.props;
        return immGlobalPosition.getIn(['savings', 'allSavings']).find(option => {
            return option.get('id') === depositId;
        });
    }

    buildErrorNoAdditionalAccounts() {
        const title = formatText('depositChangeAccount-noAdditionalAccountsTitle');
        const subTitle = formatText('depositChangeAccount-noAdditionalAccountsSubTitle');
        const textLink = formatText('depositChangeAccount-textLinkGoBack').toUpperCase();
        const goBackHandler = this.handleErrorGoBack;
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subTitle}
                textLink={textLink}
                goBackHandler={goBackHandler}
            />
        )
    }

    buildErrorFeedback() {
        const title = formatText('depositChangeAccount-errorTitle');
        const subTitle = formatText('depositChangeAccount-errorSubTitle');
        const textLink = formatText('depositChangeAccount-textLinkGoBack').toUpperCase();
        const goBackHandler = this.handleErrorGoBack;
        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subTitle}
                textLink={textLink}
                goBackHandler={goBackHandler}
            />
        );
    }

    buildSuccessfulFeedback() {
        const title = formatText('depositChangeAccount-successTitle');
        const subTitle = formatText('depositChangeAccount-successSubTitle');
        const textLink = formatText('depositChangeAccount-textLinkGoBack').toUpperCase();
        const goBackHandler = this.handleErrorGoBack;
        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                subtitle={subTitle}
                textLink={textLink}
                goBackHandler={goBackHandler}
            />
        );
    }

    handleAccountFromChange(accountId) {
        const { setAsociatedAccountId } = this.props;

        if (accountId) {
            setAsociatedAccountId(accountId);
        }
    }

    filterAccounts(immAccountsList, immAccountsMap) {
        const { immDepositChangeAccount } = this.props;
        const actualAssoicatedContractNumber = immDepositChangeAccount.getIn(['asociatedAccount', 'contrato', 'numerodecontrato']);

        let filterAccountIds = [];

        immAccountsList.forEach(accountIdItem => {
            const account = immAccountsMap.get(accountIdItem);
            const isAccountProduct = account.get('newProduct') === '300';
            const contractNumber = account.get('contractNumber');
            const isActiveAccount = account.getIn(['filters', 'valid']);

            if (isActiveAccount && isAccountProduct && contractNumber !== actualAssoicatedContractNumber) {
                filterAccountIds.push(accountIdItem);
            }
        });

        return filterAccountIds;
    }

    buildPreleaveCancelModal() {
        const { immDepositChangeAccount } = this.props;
        const isCancelModalVisible = immDepositChangeAccount.get('showCancelModal');

        return (
            <PreleaveCancelModal
                isOpen={isCancelModalVisible}
                onCancel={this.handleCancelWizard}
                onCloseModal={this.handleHideCancelModal}
                onStayHere={this.handleHideCancelModal}
            />
        );
    }

    buildWizard() {
        const { immDepositChangeAccount, setVisibleStep, validateStep, handleFinish } = this.props;
        const immSteps = immDepositChangeAccount.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immDepositChangeAccount.get('visibleStep');

        // @keys
        const confirmBtnLabel = 'depositChangeAccount-wizardConfirmBtn';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel: () => { },
            finish: handleFinish,
            cancel: this.handleShowCancelModal
        };

        const step1 = (
            <WizardStep
                position="first"
                cancelButton={true}
                isLoading={false}
                nextBtnModifier="primary">
                {this.buildStep1()}
            </WizardStep>)

        const step2 = (
            <WizardStep
                cancelButton={true}
                immFinalButton={confirmBtnLabel}
                isLoading={false}
                addLoadingBehaviour={true}
                omitPreviousButton={false}
                position="last"
                nextBtnModifier="primary"
            >
                {this.buildStep2()}
            </WizardStep>);

        const wizardProps = {
            actions,
            fullWidth: false,
            immSteps,
            stepsAmount,
            visibleStep,
            viewMode: WIZARD_VERTICAL_VIEW_MODE
        }
        const wizard = (
            <Wizard {...wizardProps}>
                {step1}
                {step2}
            </Wizard>
        )
        return wizard;
    }

    buildStep1() {
        const { immAccounts, immDepositChangeAccount } = this.props;
        const accountsIndexes = this.filterAccounts(immAccounts.get('byOrder'), immAccounts.get('byId'));
        const accountLabel = formatText('depositChangeAccount-accountSelectLabel');
        const firstStepError = immDepositChangeAccount.get("errorReceivedMsg");
        const selectedAccountId = immDepositChangeAccount.getIn(['steps', FIRST_STEP, 'newAsociatedAccountId']);
        const step1 = (
            <article className="change-account no-print-out">
                <header>
                    <h1 className="change-account__title"><FormattedText value="depositChangeAccount-wizardStep1Title" /></h1>
                </header>
                <section className="change-account__content">
                    <BlockInfo extraClass="change-account__block-info">
                        <FormattedText value="depositChangeAccount-wizardStep1Script" />
                    </BlockInfo>
                    <div className="change-account__content-right">
                        <DropdownAccounts
                            label={accountLabel}
                            immAccounts={immAccounts.get('byId')}
                            accountsIndexes={accountsIndexes}
                            currentAccountId={selectedAccountId}
                            onAccountChange={this.handleAccountFromChange}
                            error={!!firstStepError}
                            errorMsg={firstStepError}
                            placeholder={formatText('depositChangeAccount-accountSelectPlaceholder')}
                        />
                    </div>
                    <div className="change-account__content-reset" />
                </section>
            </article>
        );

        return step1;
    }

    buildStep2() {
        const { match: { params: { depositId } }, immDepositChangeAccount, immAccounts, immDeposits } = this.props;
        const operative = formatText('depositChangeAccount-wizardStep2Script1');
        const selectedAccountIban = formatIbanString(immDepositChangeAccount.getIn(['steps', FIRST_STEP, 'iban']));
        const deposit = this.getDeposit();
        const depositProduct = deposit.get('product').trim();
        const originAccountContractNumber = deposit.get('contractNumber').trim();
        const originAccount = API_ENTERPRISE_NUMBER + API_CENTER + depositProduct + originAccountContractNumber;
        const selectedAccountId = immDepositChangeAccount.getIn(['steps', FIRST_STEP, 'newAsociatedAccountId'])
        const destinationAccount = immAccounts.getIn(['byId', selectedAccountId, 'iban']);
        const productDescription = deposit.get("productDescription") || immDeposits.getIn(["byId", depositId, "description"]) || EMPTY_CONCEPT;
        const operationParams = {
            originAccount,
            destinationAccount,
        };

        const step2 = (
            <article>
                <header className="change-account-step2__header">
                    <h1 className="change-account-step2__title"><FormattedText value="depositChangeAccount-wizardStep2title" /></h1>
                </header>
                <section className="change-account-step2__content">
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    <p className="change-account-step2__header-info"><FormattedText value="depositChangeAccount-wizardStep2Script2" /></p>
                    <OKInformativeList columns={1}>
                        <OKInformativeListItem
                            title={formatText('depositChangeAccount-wizardStep2DepositLabel')}
                            bodyText={productDescription.toUpperCase()}
                        />
                        <OKInformativeListItem
                            title={formatText('depositChangeAccount-wizardStep2AccountLabel')}
                            bodyText={selectedAccountIban}
                        />
                    </OKInformativeList>
                    <hr />
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    <VerifyOtpStep
                        operationType={DEPOSIT_CHANGE_ACCOUNT}
                        operationParams={operationParams}
                    />
                </section>
            </article>
        );
        return step2;
    }

    render() {
        const { match: { params: { depositId } }, immDepositChangeAccount, immAccounts, immDeposits } = this.props;
        const { submitSuccessful, submitError, asociatedAccountFetched } = immDepositChangeAccount.toJS();
        const deposit = this.getDeposit();
        const productDescription = deposit.get("productDescription") || immDeposits.getIn(["byId", depositId, "description"]) || formatText('breadcrumb-depositUndefined');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-depositos'),
                url: '/myprofile/deposits'
            },
            {
                text: productDescription,
                url: `/myprofile/deposits/${depositId}/details`
            },
            {
                text: formatText('depositChangeAccount-pageTitle'),
                url: ''
            }
        ];

        let content = (
            <LoadingSection />
        );

        if (submitError) {
            content = this.buildErrorFeedback();
        } else if (submitSuccessful) {
            content = this.buildSuccessfulFeedback();
        } else if (asociatedAccountFetched) {
            const availableAccountsForDeposit = immAccounts.get('byId').filter(account => {
                return (account.get('newProduct') === '300' && (account.get('contractNumber') !== immDepositChangeAccount.getIn(['asociatedAccount', 'contrato', 'numerodecontrato'])));
            });

            if (availableAccountsForDeposit.size > 0) {
                content = (
                    <div>
                        {this.buildWizard()}
                        {this.buildPreleaveCancelModal()}
                    </div>
                )
            } else {
                content = this.buildErrorNoAdditionalAccounts();
            }
        }

        return (
            <div className="deposit-change-account-view">
                <OKHeaderCC
                    title="depositChangeAccount-pageTitle"
                    showBreadBrumb={true}
                    breadcrumbConfig={mappingBreadcrumb}
                />
                <section className="deposit-change-account-view__body">
                    {content}
                </section>
            </div>
        );
    }
}

DepositChangeAccountView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immDepositChangeAccount: PropTypes.object.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired,
    resetWizard: PropTypes.func.isRequired,
    requestAsociatedAccount: PropTypes.func.isRequired,
    setAsociatedAccountId: PropTypes.func.isRequired,
    showCancelModal: PropTypes.func.isRequired,
    setDepositId: PropTypes.func.isRequired,
    immDeposits: PropTypes.object.isRequired
}

module.exports.DepositChangeAccountView = connect(
    state => ({
        immDepositChangeAccount: state.depositChangeAccount,
        immGlobalPosition: state.globalPosition,
        immAccounts: state.accounts,
        immDeposits: state.deposits,
        immDepositDetails: state.depositsDetails,
        immGapAccess: state.gapAccess
    }),
    {
        setVisibleStep: depositChangeAccountActions.setVisibleStep,
        validateStep: depositChangeAccountActions.validateStep,
        resetWizard: depositChangeAccountActions.resetWizard,
        handleFinish: depositChangeAccountActions.handleFinish,
        requestAsociatedAccount: depositChangeAccountActions.requestAsociatedAccount,
        setAsociatedAccountId: depositChangeAccountActions.setAsociatedAccountId,
        showCancelModal: depositChangeAccountActions.showCancelModal,
        setDepositId: depositChangeAccountActions.setDepositId
    }
)(withRouter(DepositChangeAccountView));
